import React, { createContext, useState, useContext, useEffect } from 'react'
import { readProceduresPerformed } from './examination-procedures-utils'
import { message } from 'antd'
import { handleError } from '../../lib/utils'

const ProceduresContext = createContext()

export const ProceduresProvider = ({ children, bookingData, userRef }) => {
  const [proceduresPerformed, setProceduresPerformed] = useState([])
  const [proceduresPerformedLoading, setProceduresPerformedLoading] = useState(false)

  const fetchProceduresPerformed = async () => {
    if (!bookingData?._id && !userRef) return

    setProceduresPerformedLoading(true)
    try {
      const tmpData = await readProceduresPerformed({
        bookingRef: bookingData?._id,
        userRef
      })
      setProceduresPerformed(tmpData)
    } catch (e) {
      message.error(handleError(e))
    } finally {
      setProceduresPerformedLoading(false)
    }
  }

  useEffect(() => {
    if (bookingData?._id || userRef) {
      fetchProceduresPerformed()
    }
  }, [bookingData, userRef])

  const updateProceduresPerformed = (updatedProcedures) => {
    setProceduresPerformed(updatedProcedures)
  }

  return (
    <ProceduresContext.Provider
      value={{
        proceduresPerformed,
        setProceduresPerformed: updateProceduresPerformed,
        proceduresPerformedLoading,
        fetchProceduresPerformed
      }}
    >
      {children}
    </ProceduresContext.Provider>
  )
}

export const useProcedures = () => useContext(ProceduresContext)
